import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sitesService } from '../services';
import SiteSheetsTab from '../components/SiteSheetsTab';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ClipboardList, ArrowLeft } from 'lucide-react';

export default function SiteForwardSheetsPage() {
  const navigate = useNavigate();
  const [sites, setSites] = useState([]);
  const [selectedSiteId, setSelectedSiteId] = useState('');

  useEffect(() => {
    const loadSites = async () => {
      try {
        const data = await sitesService.list({ limit: 500 });
        setSites(Array.isArray(data) ? data : data.sites || data.items || []);
      } catch { /* silent */ }
    };
    loadSites();
  }, []);

  const selectedSiteName = sites.find(s => String(s.id) === selectedSiteId)?.name;

  return (
    <div className="space-y-6" data-testid="site-forward-sheets-page">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/stocktaking/dashboard')}
          data-testid="back-to-dashboard">
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
            <ClipboardList className="h-6 w-6 text-slate-600" />
            Stock Forward Sheets
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Manage forward sheet templates per site
          </p>
        </div>
      </div>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Select Site</CardTitle>
        </CardHeader>
        <CardContent>
          <Select value={selectedSiteId} onValueChange={setSelectedSiteId}>
            <SelectTrigger className="w-full max-w-md" data-testid="sheets-site-select">
              <SelectValue placeholder="Choose a site..." />
            </SelectTrigger>
            <SelectContent>
              {sites.map(s => (
                <SelectItem key={s.id} value={String(s.id)}>{s.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </CardContent>
      </Card>

      {selectedSiteId ? (
        <Card key={selectedSiteId}>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">{selectedSiteName}</CardTitle>
          </CardHeader>
          <CardContent>
            <SiteSheetsTab siteId={Number(selectedSiteId)} />
          </CardContent>
        </Card>
      ) : (
        <div className="text-center py-12 text-muted-foreground">
          <ClipboardList className="h-12 w-12 mx-auto mb-3 opacity-30" />
          <p>Select a site above to manage its stock forward sheets</p>
        </div>
      )}
    </div>
  );
}
